import { HelpersModule } from "../helpers/helpers";
import { UrlHelperModule } from "../helpers/urlHelper";

const helpersModule = new HelpersModule();

export class ConsultantFilterModule {

    constructor() {
        this.init();
    }

    pageload() {
        var that = this;

        $(document).ready(function () {           
           
            var searchParams = new URLSearchParams(window.location.search);
            var consultantType = searchParams.get("filterConsultantType");
            $("#consultantType").val(consultantType);
            if (consultantType == "GP") {
                $("#filterByBookable").attr("disabled", true);
            }

            that.CollapseOnlyOnMobile();
           
        });
    }   

    isMobileDevice() {
        var windowWidth = jQuery(window).width();
        if (windowWidth < 992) 
        {
            return true;
        }
    }

    CollapseOnlyOnMobile() {
        if (this.isMobileDevice()) {
            $("#DetailsSearchForm").find(".accordion-text__header").trigger('click');
            $(".consultant-search-form__filter-bar .accordion-text__header").trigger('click');
        }
    }

    ButtonClicks() {
        $("#filterConsultants").submit(function (e) {
            e.preventDefault();

            var actionUrl = $(this).find("input[name='actionUrl']").val();
            
            // store the checkbox value in a hidden field
            var selectedCheckboxes = [];
            $(".locationarea").find(".locationcb:checked").each(function () {
                selectedCheckboxes.push($(this).val());
            });
            if (selectedCheckboxes.length > 0) {
                $("#filterByLocation").val(selectedCheckboxes.join("-"))
            }

            var letter = $(this).find("input[name='filterByLetter']:checked").val();
            if (typeof letter == 'undefined') {
                letter = "";
            }

            var bookable = $("#filterByBookable").prop("checked");
            if (typeof bookable == 'undefined') {
                bookable = "";
            }

            var searchParams = new URLSearchParams(window.location.search);        
          
            var consultantType = searchParams.get("filterConsultantType");
            var treatmentOrSpeciality = searchParams.get("filterTreatmentSpeciality");

            if (consultantType == "GP") {
                $("#filterByBookable").attr("disabled", "disabled");
            }
            else if (consultantType == null) {
                consultantType = "consultant";
                treatmentOrSpeciality = "";
            }

            location.href = actionUrl + "?filterByLetter=" + letter + "&filterByLocation=" + $("#filterByLocation").val() + "&filterByTreatment=" + $("#filterByTreatment").val() + "&filterBySpecialty=" + $("#filterBySpecialty").val() + "&filterTreatmentSpeciality=" + treatmentOrSpeciality + "&filterConsultantType=" + consultantType;
            return true;
        });

        $("#resetSearch").on('click', function () {
            var actionUrl = $("#filterConsultants").find("input[name='actionUrl']").val();
            var locationChkBox = $(".locationarea").find(".locationcb:checked");
            $(locationChkBox).removeAttr("checked");
            $("#filterByLocation").val("");
            $("#filterByTreatment").val("");
            $("#filterBySpecialty").val("");
            $("#filterByBookable").attr("checked", false);
            $(".radio-custom").next("label").removeClass("checked~label");

            var lettercheckbox = $("#filterConsultants").find("input[name=filterByLetter]:checked");
            $(lettercheckbox).removeAttr("checked");

            $(".filterByLetter").removeAttr("checked");
            var url = actionUrl + "?filterByLetter=" + "" + "&filterByLocation=" + $("#filterByLocation").val() + "&filterByTreatment=" + $("#filterByTreatment").val() + "&filterBySpecialty=" + $("#filterBySpecialty").val() + "&filterTreatmentSpeciality=" + treatmentOrSpeciality;

            $("#filterConsultants").attr('action', url).submit();

        });
    }

    init() {
        this.pageload();
        this.ButtonClicks();
    }
}
